export * from "./alignment";
//# sourceMappingURL=index.js.map